import React from "react";
import { Modal, TableAdv } from "../../../../../../components";
import { Employepaymentdetailsrows } from "../../../../../../assets/data/candidatesData";
import { mapTableRows } from "../../../../../../utils";


const BankInformationModal = ({ open, onClose, rowData }) => {

  const EmployepaymentdetailsColumns = [
    { key: "NameinBankAccount", label: "Name in Bank Account" },
    { key: "BankName", label: " Bank Name" },
    { key: "AccountType", label: " Account Type " },
    { key: "AccountNumber", label: " Account Number" },
    { key: "DepositAmount", label: " Deposit Amount" },
    { key: "Address", label: " Address" },
    { key: "Status", label: "Status" },
  ];

  const tablerowData = Employepaymentdetailsrows;
  const mappedRows = mapTableRows(tablerowData, EmployepaymentdetailsColumns);

  return (
    <Modal isOpen={open} onClose={onClose} title=" Vendor bank information" width="max-w-7xl">
      <TableAdv
        tableId={`accountspayable_payments_editpayment_viewbankdetails`}
        columns={EmployepaymentdetailsColumns}
        rows={mappedRows}
        hideToolBar = {true}
      />
    </Modal>
  );
};

export default BankInformationModal;
